export default __webpack_public_path__ + "2021 Engineering entangled photon pairs with metal– organic frameworks.pdf";